// DroppableSlot component
import React from 'react'
import { useDroppable } from '@dnd-kit/core'
import { StackedImage } from 'steps/drag-and-drop/components/StackedImage'

export const DroppableSlotMatchDrop = ({
  background,
  droppedCard,
  resetSlot,
  isCorrectAnswer,
  isWrongAnswer,
  checkingMatches = true,
  gameFinished,
  wrapperStyle,
  isDuplicateCardId,
  showCorrectAnswer,
  validatedPairs,
  gameType,
  draggableCard,
  isOccupied,
  isComingFromBottom,
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id: background.id,
  })

  const resetSlotClick = () => {
    resetSlot(background.id)
  }

  const cursorStyle =
    isOver && isOccupied && isComingFromBottom ? 'not-allowed' : 'unset'

  const correctCardId =
    validatedPairs &&
    validatedPairs.find(pair => pair.pair.cardImageId === droppedCard.id)?.pair
      .correctCardId

  const imageId = showCorrectAnswer ? correctCardId : droppedCard?.id

  return (
    <div style={wrapperStyle} ref={setNodeRef}>
      {droppedCard ? (
        <StackedImage
          isDuplicateCardId={isDuplicateCardId}
          image={imageId}
          backgroundImage={background}
          isReplacing={gameFinished ? false : isOver}
          gameFinished={gameFinished}
          isDropped
          onClick={gameFinished ? () => {} : resetSlotClick}
          className={'droppable-slot'}
          isWrongAnswer={isWrongAnswer}
          isCorrectAnswer={isCorrectAnswer || showCorrectAnswer}
          isComingFromBottom={isComingFromBottom}
          draggableCard={draggableCard}
          checkingMatches={checkingMatches}
          cursorStyle={cursorStyle}
          gameType={gameType}
        />
      ) : (
        <StackedImage
          gameFinished={gameFinished}
          image={background}
          gameType={gameType}
          className={'droppable-slot' + (isOver ? ' is-over' : '')}
        />
      )}
    </div>
  )
}
